import { Component, Input, OnDestroy } from '@angular/core';
import { ItemService } from '../../services/item.service';
import { Product } from 'src/app/modules/warehouse/modules/product/interfaces/product';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddItemComponent } from '../add-item/add-item.component';
import { Subscription } from 'rxjs';
import { Item } from 'src/app/modules/order/interface/item';

@Component({
  selector: 'items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.css']
})

export class ItemsComponent implements OnDestroy {

  /**
   * @var Product[]
   */
  @Input()
  public products: Product[];

  /**
   * @param Item[]
   */
  public items: Item[];

  /**
   * @var Subscription
   */
  private itemSub: Subscription;

  /**
   * Der bearbeitungsmodus (retail/whokesake)
   *
   * @var string
   */
  @Input()
  public mode: string;

  constructor(
    public itemService: ItemService, private toast: ToastrService, private modal: NgbModal
  ) {
    this.itemSub = this.itemService.getItems()
      .subscribe(this.setItems);
  }

  /**
   * Funktion zum entfernen der vorhandenen Subscription
   */
  ngOnDestroy() {
    this.itemSub.unsubscribe();
  }

  /**
   * Setter für die Membervariable Items
   *
   * @param items
   */
  public setItems = (items: Item[]) => {
    this.items = items;
  }

  /**
   * Funktion zum öffnen des Modals zum hinzufügen einer neuen Position
   */
  public openAddItem = () => {
    const modal = this.modal.open(AddItemComponent, { size: 'lg', backdrop: 'static' });
    modal.componentInstance.setProducts(this.products);
    modal.result.then(
      newItem => {
        this.itemService.addItem(newItem);
      },
      error => {
        console.log(error);
      }
    );
  }

  /**
   * Gibt den Preis eines Items zurück
   *
   * @param item
   *  * @returns number
   */
  public getFullPrice = (item: Item) => {
    const price = this.getItemPrice(item);

    return (price * item.Quantity).toFixed(2);
  }

  /**
   * @param item
   * @returns number
   */
  public getPrice = (item: Item) => {
    const price = this.getItemPrice(item);
    return price.toFixed(2);
  }

  /**
   * Gibt den in Preis einer Position anhand des, in der Klasse gesetzten Modus zurück
   *
   * @param item
   */
  private getItemPrice = (item: Item) => {
    if (this.mode === 'wholesale') {
      return item.Product.WholesalePrice;
    }

    return item.Product.Price;
  }

}
